import React from "react";
import { Button } from "react-bootstrap";

export default class TCButtonPanel extends React.Component {
    constructor(props) {
        super(props);
        //this.state = {
        //    buttons : "submit,delete,verify,deny,recall"
        //}
    }

    render() {
        const props = this.props;
        const supportButtons = ["submit", "delete", "verify", "deny", "recall", "close", "recall-approved"];
        const buttonTexts = ["submit", "delete", "verify", "deny", "recall", "close", "recall approved timecard"];
        const callBacks = [props.onSubmit, props.onDelete, props.onVerify, props.onDeny, props.onRecall, props.onClose, props.onRecallApproved];
        const cols = [];
        let addSep = false;
        const buttonsArr = props.buttons ? props.buttons.split(",") : [];
        for (let i = 0; i < supportButtons.length; i++) {

            if (buttonsArr.includes(supportButtons[i])) {
                if (addSep) {
                    cols.push(<div className="col-md-4" key={`sep${i}`}></div>);
                }

                cols.push(
                    <div className="col-md-4" key={`button${i}`}>
                        <Button className="btn-info ap-fullsize"
                            onClick={callBacks[i]}>{buttonTexts[i].toUpperCase()}</Button>
                    </div>
                );
                addSep = true;
            }
        }

        if (this.props.hidden === true) return null;

        return (
            <div className="container">
                <div className="row ap-tc-button-row">
                    {cols}
                </div>
            </div>
        );
    }
}